/** Даты и время: ISO 8601 (UTC на сервере, локальная зона пользователя в UI). */

export function toDateInputValue(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function todayInputValue(): string {
  return toDateInputValue(new Date());
}

export function addDaysInputValue(days: number, from = new Date()): string {
  const date = new Date(from.getTime());
  date.setDate(date.getDate() + days);
  return toDateInputValue(date);
}

export function parseIso(iso: string | null | undefined): number | null {
  if (!iso) return null;
  const value = Date.parse(iso);
  return Number.isNaN(value) ? null : value;
}

/**
 * Окно доступности паспортных данных модератору (FR-DOC-04):
 * период от брони до окончания визита включительно.
 */
export function isWithinVisitWindow(
  reservedAt: string | null | undefined,
  endsAt: string | null | undefined,
  now: Date = new Date(),
): boolean {
  const start = parseIso(reservedAt);
  const end = parseIso(endsAt);
  if (start === null || end === null) return false;
  const current = now.getTime();
  return current >= start && current <= end;
}

/** «1 ч 30 мин» — длительность экскурсии. */
export function formatDuration(minutes: number | null | undefined): string {
  if (!minutes || minutes <= 0) return '—';
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  if (hours === 0) return `${rest} мин`;
  if (rest === 0) return `${hours} ч`;
  return `${hours} ч ${rest} мин`;
}

/** Часы и минуты локальной даты — «09:30». */
export function formatTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
}

/** Дата и время в формате пользователя. */
export function formatDateTimeLocal(iso: string | null | undefined): string {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleString('ru-RU', { dateStyle: 'medium', timeStyle: 'short' });
}

/** Проценты из доли (0…1). */
export function formatPercent(ratio: number | null | undefined): string {
  if (typeof ratio !== 'number' || Number.isNaN(ratio)) return '—';
  const percent = ratio <= 1 ? ratio * 100 : ratio;
  return `${percent.toFixed(1).replace('.', ',')} %`;
}
